import { CollectionClient as CollectionClientBase } from "./collection.generated";
import { httpResult, pipeRevivers } from "./utils";
const dutchDisplayNames = new Intl.DisplayNames([
    'nl'
], {
    type: 'language'
});
const parseLanguageCodesToDisplayNames = (prop)=>(key, value)=>key === prop ? value === null || value === void 0 ? void 0 : value.map((code)=>dutchDisplayNames.of(code)) : value;
// Extending the generated client allows us to do some configuration, including
// manipulation of returned data using a "reviver" function.
// https://github.com/RicoSuter/NSwag/wiki/TypeScriptClientGenerator#add-a-custom-jsonparse-reviver-function
class CollectionClient extends CollectionClientBase {
    constructor(baseUrl = window.location.origin, http){
        super(baseUrl, http);
        this.jsonParseReviver = pipeRevivers([
            parseLanguageCodesToDisplayNames("languages")
        ]);
    }
}
const client = new CollectionClient(window.location.origin);
export const fetchCollectionItemByISBN = (isbn)=>()=>httpResult(async ()=>{
            const result = await client.getTitleByISBN(isbn);
            return result.Result;
        });
const itemCache = new Map();
export const fetchCollectionItemById = (id)=>()=>httpResult(async ()=>{
            if (itemCache.has(id)) return itemCache.get(id);
            const result = await client.getItemById(id);
            itemCache.set(id, result.Result);
            return result.Result;
        });
export const allLocationsId = 'all' // Sentinel: means "all locations".
;
export const allLocationsLabel = 'Alle locaties';
export const fetchSearchResponse = (params)=>()=>httpResult(async ()=>{
            const { query, limit, offset, medium, genre, location, status, ageFrom, ageTo } = params;
            const result = await client.search(query, medium, genre, location == allLocationsId ? undefined : location, status, ageFrom, ageTo, limit, offset);
            result.Result.filter((i)=>!i.MoreDataAvailable).forEach((item)=>itemCache.set(item.Id, item));
            return result;
        });
export const fetchDefaultFacets = ()=>httpResult(async ()=>await client.getDefaultFacets());
export const fetchRecommendations = (id)=>()=>httpResult(async ()=>{
            const result = await client.recommendById(id);
            result.Result.forEach((item)=>itemCache.set(item.Id, item));
            return result.Result;
        });
export const allMedia = [
    "book",
    "audiobook",
    "largeletterbook",
    "comic",
    "magazine",
    "music",
    "video",
    "videogame",
    "game",
    "unknown"
];
const isMedium = (value)=>allMedia.includes(value);
const asMedium = (value)=>isMedium(value) ? value : "unknown";
export const asMediaFacet = (facet)=>({
        ...facet,
        Id: asMedium(facet.Id)
    });
export const mediaLabel = {
    book: "Boek",
    audiobook: "Luisterboek",
    largeletterbook: "Grootletterboek",
    comic: "Stripboek",
    magazine: "Magazine",
    music: "Muziek",
    video: "Film of Serie",
    videogame: "Computerspel",
    game: "Spel",
    unknown: "Overig"
};
export const mediaLabels = {
    book: "Boeken",
    audiobook: "Luisterboeken",
    largeletterbook: "Grootletterboeken",
    comic: "Stripboeken",
    magazine: "Magazines",
    music: "Muziek",
    video: "Films en Series",
    videogame: "Computerspellen",
    game: "Spellen",
    unknown: "Overig"
};
export const allAvailabilities = [
    "available",
    "notAvailable",
    "onRequest"
];
const isAvailability = (value)=>allAvailabilities.includes(value);
const asAvailability = (value)=>isAvailability(value) ? value : "onRequest";
export const asAvailabilityFacet = (facet)=>({
        ...facet,
        Id: asAvailability(facet.Id)
    });
// Labels for the per-item availability badge (see CollectionOverviewResult).
export const availabilityLabels = {
    available: "Nu beschikbaar",
    notAvailable: "Uitgeleend",
    onRequest: "Reserveerbaar"
};
// Availability filter options that shape how availability is presented on the collection overview
// page. The set shown to the user depends on whether a location is selected.
export const availabilityOptionsWithLocation = [
    "availableHere",
    "availableElsewhere",
    "onLoan",
    "onRequest"
];
export const availabilityOptionsWithoutLocation = [
    "availableAnywhere",
    "onLoan",
    "onRequest"
];
const allAvailabilityOptions = [
    "availableHere",
    "availableElsewhere",
    "availableAnywhere",
    "onLoan",
    "onRequest"
];
const isAvailabilityOption = (value)=>allAvailabilityOptions.includes(value);
export const asAvailabilityOptionFacet = (facet)=>isAvailabilityOption(facet.Id) ? {
        ...facet,
        Id: facet.Id
    } : null;
export const availabilityOptionLabels = {
    availableHere: "Aanwezig",
    availableElsewhere: "Op andere locatie",
    availableAnywhere: "Aanwezig",
    onLoan: "Uitgeleend",
    onRequest: "Op aanvraag"
};
